import { useChatContext } from 'stream-chat-react'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Switch from '@mui/material/Switch'
import LinkIcon from '@mui/icons-material/Link'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import { useCopyConversationLink } from '../Channel/MessagingChannelHeader/ShareButton'
import { useSlackSubscription } from '../Channel/MessagingChannelHeader/SubscribeButton'

// The thread's actions on a phone, where the profile holds them as iOS
// details screens do: copy its link, and Slack notifications as a switch.
// Rename and delete stay on the desktop.
const ConversationActions = () => {
  const { channel } = useChatContext()
  const copyLink = useCopyConversationLink(channel)
  const slack = useSlackSubscription(channel)

  return (
    <>
      <List sx={{ width: '100%', mt: 1 }}>
        <ListItemButton onClick={copyLink}>
          <ListItemIcon>
            <LinkIcon />
          </ListItemIcon>
          <ListItemText primary="Copy link to conversation" />
        </ListItemButton>
        {slack.available && (
          <ListItemButton onClick={slack.toggle} disabled={slack.loading}>
            <ListItemIcon>
              <NotificationsNoneIcon />
            </ListItemIcon>
            <ListItemText primary="Slack notifications" />
            <Switch
              edge="end"
              checked={slack.subscribed}
              tabIndex={-1}
              inputProps={{ 'aria-hidden': true }}
            />
          </ListItemButton>
        )}
      </List>
      {slack.connectDialog}
    </>
  )
}

export default ConversationActions
